export const WARNING_CODE_FIELDS = ['IOWRN1', 'IOWRN2', 'IOWRN3'] as const;

export type WarningCodeField = (typeof WARNING_CODE_FIELDS)[number];

export const WARNING_CODES = [
  'ALL',
  'CDS',
  'CLN',
  'DNR',
  'NC',
  'NLA',
  'NR',
  'PLO',
  'POA',
  'TPH',
  'PRJ',
  'CC1',
  'ST1',
  'CC2',
  'ST2',
  'CC3',
  'ST3',
  'PUG',
  'RAN',
  'RAM',
  'MTO',
  'CSE',
  'NSE',
  'CWS',
  'BPK',
  'SPK',
  'PRE',
] as const;

export type WarningCode = (typeof WARNING_CODES)[number];

export const HARD_WC3_CODES: readonly string[] = [];

const HARD_PLACEMENT: Readonly<Record<string, WarningCodeField>> = {
  NLA: 'IOWRN1',
  PLO: 'IOWRN1',
  POA: 'IOWRN2',
};

const PREFERRED_SLOT: Readonly<Record<string, WarningCodeField>> = {
  ALL: 'IOWRN1',
  CDS: 'IOWRN1',
  CLN: 'IOWRN1',
  DNR: 'IOWRN3',
  NC: 'IOWRN3',
  NLA: 'IOWRN1',
  NR: 'IOWRN2',
  PLO: 'IOWRN1',
  POA: 'IOWRN2',
  TPH: 'IOWRN1',
  PRJ: 'IOWRN3',
  CC1: 'IOWRN1',
  ST1: 'IOWRN1',
  CC2: 'IOWRN2',
  ST2: 'IOWRN2',
  CC3: 'IOWRN3',
  ST3: 'IOWRN3',
  PUG: 'IOWRN3',
  RAN: 'IOWRN3',
  RAM: 'IOWRN3',
  MTO: 'IOWRN3',
  CSE: 'IOWRN1',
  NSE: 'IOWRN1',
  CWS: 'IOWRN1',
  BPK: 'IOWRN1',
  SPK: 'IOWRN1',
  PRE: 'IOWRN3',
};

export function warningCodePlacement(
  field: string,
  value: string | null,
  hardWc3: readonly string[] = HARD_WC3_CODES,
): { slot: WarningCodeField; required: boolean } | null {
  if (value === null || !WARNING_CODES.some((code) => code === value)) {
    return null;
  }
  const hardSlot = HARD_PLACEMENT[value] ?? wc3Slot(value, hardWc3);
  if (hardSlot !== undefined) {
    return field === hardSlot ? null : { slot: hardSlot, required: true };
  }
  const preferred = PREFERRED_SLOT[value];
  if (preferred === undefined || field === preferred) return null;
  return { slot: preferred, required: false };
}

function wc3Slot(
  value: string,
  hardWc3: readonly string[],
): WarningCodeField | undefined {
  return hardWc3.includes(value) ? 'IOWRN3' : undefined;
}
